import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//import { IsNotAuthorizedGuard } from '../core/guard/is-not-authorized.guard';

import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { LeasingEndowmentRequestComponent } from './leasing-endowment-request/leasing-endowment-request.component';
import { LoginComponent } from './login/login.component';
import { ConfirmNewPasswordComponent } from './login/confirm-new-password/confirm-new-password.component';
import { EmailVerificationComponent } from './register/email-verification/email-verification.component';
import { MfaAuthenticationComponent } from '../shared/components/mfa-authentication/mfa-authentication.component';
import { RegisterComponent } from './register/register.component';
import { LandingComponent } from './landing/landing.component';
import { Landing2Component } from './landing2/landing2.component';
import { IsNotAuthorizedGuard } from '../core/guard/is-not-authorized.guard';
import { DidacticComponent } from './didactic/didactic.component';
import { LoanRequestComponent } from './loan-request/loan-request.component';
import { GeneralServiceComponent } from './general-service/general-service.component';
import { InteriorRouteComponent } from './interior-route/interior-route.component';
import { ListRequestsComponent } from './list-requests/list-requests.component';
import { DetailRequestComponent } from './detail-request/detail-request.component';
import { MenuComponent } from './menu/menu.component';
import { CampaignDetailComponent } from './campaing-detail/campaign-detail.component';
import { AuthorizationsComponent } from './authorizations/authorizations.component';
import { TransfersComponent } from './transfers/transfers.component';
import { FunctionRequestComponent } from './function-request/function-request.component';
import { CampaignRequestComponent } from './campaign-request/campaign-request.component';
import { JudgementsComponent } from './judgements/judgements.component';
import { BookVehicleComponent } from './book-vehicle/book-vehicle.component';
import { ProjectsComponent } from './projects/projects.component';
import { RedPlatesComponent } from './red-plates/red-plates.component';
import { ESComponent } from './e-s/e-s.component';
import { RequestCompletedComponent } from './request-completed/request-completed.component';
import { EmployeeLeasingRequestComponent } from './employee-leasing-request/employee-leasing-request.component';
import { VoRequestComponent } from './vo-request/vo-request.component';
import { DocumentationInfoComponent } from './documentation-info/documentation-info.component';
import { ManageDataComponent } from './manage-data/manage-data.component';
import { RelativesVoComponent } from './relatives-vo/relatives-vo.component';
import { EsDetailComponent } from './es-detail/es-detail.component';
import { CompanyVoRegisterComponent } from './register/company-vo-register/company-vo-register.component';
import { ExternVoComponent } from './extern-vo/extern-vo.component';

@Component({ template: '' })
export class InitComponent {}

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    data: { header: false, footer: false }
  },
  {
    path: 'landing',
    component: LandingComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'landing-leasing',
    component: Landing2Component,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  { path: 'logout', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'confirm-new-password',
    component: ConfirmNewPasswordComponent,
    data: { header: false, footer: false }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: { header: false, footer: false }
  },
  {
    path: 'company-vo-register',
    component: CompanyVoRegisterComponent,
    data: { header: false, footer: false }
  },
  {
    path: 'register/verification-code',
    component: EmailVerificationComponent,
    data: { header: false, footer: false }
  },
  {
    path: 'register/mfa-authentication',
    component: MfaAuthenticationComponent,
    data: { header: false, footer: false }
  },
  {
    path: 'menu',
    component: MenuComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'endowment_leasing',
    component: LeasingEndowmentRequestComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'employee_leasing',
    component: EmployeeLeasingRequestComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'vo',
    component: VoRequestComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'relatives-vo',
    component: RelativesVoComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'extern-vo',
    component: ExternVoComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'request-completed',
    component: RequestCompletedComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'function',
    component: FunctionRequestComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'campaign',
    component: CampaignRequestComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'loan',
    component: LoanRequestComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  { path: 'detail-request/:requestNumber', component: DetailRequestComponent },
  {
    path: 'general_services',
    component: GeneralServiceComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'educational',
    component: DidacticComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'inner_route',
    component: InteriorRouteComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'authorizations',
    component: AuthorizationsComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'transfers',
    component: TransfersComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'judgements',
    component: JudgementsComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'red_plates',
    component: RedPlatesComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'book-vehicle/:requestNumber',
    component: BookVehicleComponent,
    data: { header: true, footer: true }
  },
  {
    path: 'campaign-detail',
    component: CampaignDetailComponent,
    canActivate: [IsNotAuthorizedGuard]
  },
  {
    path: 'list-requests',
    component: ListRequestsComponent,
    data: { header: true, footer: true }
  },
  {
    path: 'project',
    component: ProjectsComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'e-s',
    component: ESComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  {
    path: 'es-detail',
    component: EsDetailComponent
  },
  {
    path: 'documentation',
    component: DocumentationInfoComponent,
    data: { header: false, footer: true }
  },
  {
    path: 'manage-data',
    component: ManageDataComponent,
    canActivate: [IsNotAuthorizedGuard],
    data: { header: true, footer: true }
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  declarations: [InitComponent],
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'disabled',
      scrollPositionRestoration: 'top'
    })
  ],
  exports: [RouterModule]
})
export class ViewsRoutingModule {}
